import React, { useState, useCallback, useEffect, useRef } from 'react'
import { Box, ButtonProps } from '@material-ui/core'
import { Timer } from '@material-ui/icons'
import Button from 'components/Button'

interface IButtonWithTimer {
  time: number
  onClick: Function
  text: string
  variant?: ButtonProps['variant']
  color?: ButtonProps['color']
  waitForClick?: boolean
}

const ButtonWithTimer: React.FC<IButtonWithTimer> = ({
  time,
  onClick,
  text,
  variant = 'text',
  color = 'inherit',
  waitForClick = false,
}) => {
  const [count, setCount] = useState<number>(waitForClick ? 0 : time)

  const timeoutIdRef = useRef<number | null>(null)

  const buttonCount = useCallback(() => {
    timeoutIdRef.current = setTimeout(() => {
      if (count > 0) {
        setCount((prevState) => prevState - 1)
      } else {
        setCount(0)
      }
    }, 1000)
  }, [count, setCount])

  const onClickButton = async () => {
    setCount(time)
    if (onClick) await onClick()
  }

  useEffect(() => {
    buttonCount()
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current)
      }
    }
  }, [buttonCount])

  return (
    <Button variant={variant} onClick={() => onClickButton()} color={color} disabled={count > 0}>
      {count > 0 && (
        <>
          <Timer />
          <Box fontWeight='fontWeightBold' ml={1}>
            {text} {count}s
          </Box>
        </>
      )}
      {count === 0 && <Box fontWeight='fontWeightBold'>{text}</Box>}
    </Button>
  )
}

export default ButtonWithTimer
